import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import HeaderCell from 'components/HeaderCell'
import { buildTranslate } from 'locales'
import { Fields as UserProfile } from 'models/UserProfile'
import React, { useMemo } from 'react'
import { IMPORT_FILES_TAG_KEY, USER_LISTS_TAG_KEY } from '../Overview'
import Row from './Row'

const t = buildTranslate('users.view.profile.custom_tags')

const SPECIAL_TAG_KEYS = [USER_LISTS_TAG_KEY, IMPORT_FILES_TAG_KEY]

type PropsT = {
  profile: UserProfile
}

const CustomTags: React.FC<PropsT> = ({ profile }: PropsT) => {
  const filteredTags = useMemo(
    () =>
      profile.custom_tags.filter(tag => !SPECIAL_TAG_KEYS.includes(tag.key)),
    [profile.custom_tags]
  )

  return (
    <div>
      <Text.Header4 className={'mb-m'}>{t('title')}</Text.Header4>
      <Switch
        condition={filteredTags.length > 0}
        fallback={
          <Text.BodyText3 color="grey70">{t('empty_state')}</Text.BodyText3>
        }
      >
        <table className="full-width">
          <thead>
            <tr>
              <HeaderCell className={'w-50'}>{t('key')}</HeaderCell>
              <HeaderCell className={'w-50'}>{t('values')}</HeaderCell>
            </tr>
          </thead>
          <tbody>
            {filteredTags.map(tag => (
              <Row key={tag.key} tag={tag} />
            ))}
          </tbody>
        </table>
      </Switch>
    </div>
  )
}

export default CustomTags
